import api from '@edu-fe/api'
import * as get from '@ccforeverd/tool-get'
import md5 from 'blueimp-md5'
import Cookie from 'js-cookie'

const module = {
  name: 'signUp',
  info: api.create(`/course/info?userId=${Cookie.get('openid')}`),
  getGroupList: (courseId) => {
    return api.create(`/group/list?courseId=${courseId}`)
  },
  getGroupInfo: (groupId) => {
    return api.create(`/group/info?id=${groupId}`)
  },
  isSubsribe: api.create('/weixin/is/subscribe'),
  getQrcode: (groupId) => {
    return api.create(`/weixin/group/qrcode?groupId=${groupId}`)
  },

  // 标签统计
  tagReport(courseId) {
    const appId = '35e75134081b11e997ecfa163e3b12eb'
    const secret = '3b79d6d1081b11e997ecfa163e3b12eb'
    // console.log(courseId)
    // console.log(get.query())
    const data = {
      appId,
      courseId,
      timeStamp: Date.now().toString()
    }
    const query = get.add('', data) + `&key=${secret}`
    const sign = md5(query.replace('?', '')).toUpperCase()
    console.log(sign)
    // return api.create(`/report/report${query}&sign=${sign}`, {
    //   method: 'post',
    //   baseURL: 'https://mp-service.iciba.com'
    // })
  },

  // 1元训练营信息
  promoteInfo: api.create('/course/promote/info')
}

export default module
